import {
    ExcelColorsLabels, ExcelColorsValues,
    defaultFontColor, defaultBackgroundColor
} from './colorDefinitions'
import {ExcelColorsOption} from './colorOptionsSelect'

export const createExcelColorsOption = (colorName:string): ExcelColorsOption => {
    return {
        value: ExcelColorsLabels[colorName],
        label: colorName?.replace(/\_/g, ' '),
        color: ExcelColorsValues[colorName]
    }
}

export const generateOptionsForExcelColorSelect = () : ExcelColorsOption[] => {
    return Object.keys(ExcelColorsLabels).map(createExcelColorsOption)
}

export const getExcelColorOptionForValue = (value:ExcelColorsLabels): ExcelColorsOption => {
    return generateOptionsForExcelColorSelect().find(op => op.value == value)
}

export const onChangeColorOptionsSelect = (field:string, newValue:ExcelColorsOption, onChangeFather:(field:string, value: ExcelColorsLabels)=>void|null): void => {    
    if (getExcelColorOptionForValue(newValue.value)){
        onChangeFather(field, newValue.value)
    }
}

export const excelColorsSelectorValidColorValue = (field:string, value:ExcelColorsLabels, onChangeFather:(field:string, value:ExcelColorsLabels)=>void|null):ExcelColorsLabels => {
    let defaultColorLabel:ExcelColorsLabels
    switch (field){
        case 'fontColor':
            defaultColorLabel = defaultFontColor.label
            break
        case 'backgroundColor':
            defaultColorLabel = defaultBackgroundColor.label
            break
        default:
            defaultColorLabel = ExcelColorsLabels.BLACK
    }

    if(!value){
        onChangeFather(field, defaultColorLabel)
        return defaultColorLabel
    }
    return value

}